import makeConsentCookie from './makeConsentCookie';

const addSelectedCategoriesConsent = (categories) => {
    document.cookie = makeConsentCookie(categories);
};

export default addSelectedCategoriesConsent;
